export default "__VITE_ASSET__D6jJaqN1__"